import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-workorder-card',
  templateUrl: './workorder-card.component.html',
  styleUrls: ['./workorder-card.component.scss'],
})
export class WorkorderCardComponent implements OnInit {
  @Input() data: any;
  flag = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.flag = Number(params['id']) === this.data?.id;
    });
  }

  statusMap: Record<string, { text: string; class: string; desc: string }> = {
    ReplyReceived: {
      text: '等待您的回复',
      class: 'old',
      desc: '',
    },
    NoResponseReceived: {
      text: '新工单',
      class: 'new',
      desc: '',
    },
    ProactiveCompletion: {
      text: '已完结',
      class: 'close',
      desc: '',
    },
    PassiveCompletion: {
      text: '已完结',
      class: 'close',
      desc: '',
    },
    CustomerServiceCompletion: {
      text: '已完结',
      class: 'close',
      desc: '',
    },
    Processing: {
      text: '处理中',
      class: 'processing',
      desc: '工单已提交，客服会尽快处理',
    },
    Supplemented: {
      text: '已补充',
      class: 'supplemented',
      desc: '已收到您的补充信息，客服会继续处理',
    },
    NeedToSupplement: {
      text: '需补充',
      class: 'need-to-supplement',
      desc: '请根据客服提示补充信息',
    },
    ProcessCompleted: {
      text: '处理完成',
      class: 'process-completed',
      desc: '客服已处理完成，请点击查看结果',
    },
    Completed: {
      text: '已完成',
      class: 'completed',
      desc: '该工单已处理完成',
    },
  };
}
